import { createSelector, type Selector } from '@reduxjs/toolkit';
import { type RootState } from '../../stores/redux';
import { type AudioFile, NO_SOUND } from '../../hooks/useAudio';

const getState = (state: RootState): RootState => state;

const getUserPreferencesState = createSelector(
  getState,
  (state: RootState) => state.userPreferences,
);

export const getChatMessageSound: Selector<
  RootState,
  AudioFile | typeof NO_SOUND
> = createSelector(getUserPreferencesState, (state) => state.chatMessageSound);
